import { nullishDefault } from '../helpers/nullishDefault';
import { Classification } from './classification';
import { z } from 'zod';

export type ClassificationMeta = z.infer<typeof ClassificationMeta>;

export const ClassificationMeta = z.object({
    classifications: nullishDefault(z.array(Classification), []),
    debug: z.unknown(),
});
